import { render, staticRenderFns } from "./user-center.vue?vue&type=template&id=7b42edce&scoped=true"
import script from "./user-center.vue?vue&type=script&lang=js"
export * from "./user-center.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b42edce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/johnson/WebStormProject/zm/zm-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b42edce')) {
      api.createRecord('7b42edce', component.options)
    } else {
      api.reload('7b42edce', component.options)
    }
    module.hot.accept("./user-center.vue?vue&type=template&id=7b42edce&scoped=true", function () {
      api.rerender('7b42edce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/system-management/user-management/user-center.vue"
export default component.exports